import { snakeCase } from 'lodash-es';
import { getPathPageName } from './getPathPageName';
import { analytics } from './segment';

export {
  funnelAnalytics,
  type SegmentCompletedRegistrationMethod,
} from './funnelAnalytics/funnelAnalytics';
export { ratingEvent, type RatingEventArgs } from './ratings/ratingEvent';
export {
  foodRatingModalEvent,
  type FoodRatingModalEventArgs,
} from './ratings/foodFeedbackModalVisibilityEvent';
export { Utm } from './funnelAnalytics/components/Utm/Utm';
export { UTM_SESSION_STORAGE_KEY } from './funnelAnalytics/defs';
export { homepageAnalytics } from './homepage/homepageAnalytics';
export { analytics as segmentAnalytics } from './segment';
export {
  trackQuizTagSubmitted,
  type QuizTagGroup,
  type QuizTagSubmittedUIType,
  type QuizTagSubmittedMeta,
} from './quizTagSubmitted';
export {
  trackExperimentEnrollment,
  type EnrollmentMethod,
} from './track-experiment-enrollment';
export { onboardingButtonClicked } from './onboarding/onboardingAnalytics';
export { onboardingPreferencesShown } from './onboarding/onboardingPreferencesAnalytics';
export {
  trackProductClicked,
  type ProductClickedLocation,
} from './productClicked';
export { getUtmParamsFromSessionStorage } from './utils/getUtmParamsFromSessionStorage';
export { pairingInteraction } from './pairingInteraction';
export { pairingInteractionBatched } from './pairingInteractionBatched';
export { productInteraction } from './productInteraction';
export { productInteractionBatched } from './productInteractionBatched';
export { productImpressionEnded } from './productImpressionEnded';
export { pairingImpressionEnded } from './pairingImpressionEnded';
export { cookbookInteraction } from './cookbookInteraction';
export { getPathPageName } from './getPathPageName';
export {
  clearCmsRecipePageNameMappings,
  setCmsRecipePageNameMappings,
} from './cmsRecipePageNameMappings';
export {
  recipeFilterInteraction,
  groceriesFilterInteraction,
} from './filterInteraction';
export { componentInteraction } from './componentInteraction';
export { TrackPageSectionView } from './TrackPageSectionView';
export { type Location } from './types/Location';
export { type AccessedFrom } from './types/AccessedFrom';
export {
  type FeedInteractionFields,
  type InteractionContainer,
  type InteractionContentType,
  type InteractionTab,
  type RecommendationSource,
} from './types/FeedInteractionFields';
export { type Action } from './types/Action';
export {
  getCurrentTabSessionId,
  getOrCreateTabSessionId,
} from './utils/tabSession';
export {
  getCurrentNavTab,
  getNavTabFromPathname,
} from './utils/getNavTabFromPathname';
export { createRandomId } from './utils/createRandomId';
export { referralInteraction } from './referralInteraction';
export { trackCookbookShareCtaClicked } from './cookbookShareCtaClicked';
export { trackCookbookShareDestinationClicked } from './cookbookShareDestinationClicked';
export { trackProfileIconClicked } from './profileIconClicked';
export {
  trackDeliveredOrderHelpClicked,
  trackOnTheWayOrderHelpClicked,
} from './orderHelpClicked';
export {
  trackCookbookViewToggleClicked,
  type CookbookViewToggleValue,
} from './cookbookViewToggleClicked';
export {
  selfServeWizardStepViewed,
  type SelfServeWizardStepViewedParams,
} from './selfServeWizardStepViewed';
export {
  orderSkipped,
  type OrderSkippedParams,
  type OrderSkippedTab,
  type OrderStatusFilter,
} from './orderSkipped';
export {
  trackTabSessionStarted,
  trackTabSessionEnded,
  type TabName,
  type TabEntryReason,
  type TabExitReason,
} from './tabSession';
export {
  trackFoodProfileSessionStarted,
  trackFoodProfileSessionEnded,
  type FoodProfileEntryReason,
  type FoodProfileExitReason,
} from './foodProfileSession';
export {
  trackFoodProfileIngredientInteraction,
  type FoodProfileIngredientAction,
} from './foodProfileIngredientInteraction';
export {
  trackOrderStatusFilterInteraction,
  type OrderStatusFilterName,
} from './orderStatusFilter';
export {
  trackSearchFilterClicked,
  type SearchFilterValue,
} from './searchFilterClicked';
export {
  AUTO_OPEN_TUTORIAL_FLOWS,
  trackTutorialEntryClicked,
  trackTutorialFlowStarted,
  trackTutorialFlowDismissed,
  trackTutorialNavClicked,
  trackTutorialOkGotItClicked,
  type TutorialFlowName,
  type TutorialNavButtonName,
} from './tutorialFlow';
export {
  cancellationReasonSubmitted,
  type CancellationReasonScreen,
} from './cancellationReasonSubmitted';
export { searchExecuted, type SearchExecutedIndex } from './searchExecuted';
export {
  trackSurveyViewed,
  trackSurveySatisfaction,
  trackSurveyFeelings,
  trackSurveyMoreUseful,
} from './smartCartAgentSurvey';
export { snakeCase } from 'lodash-es';
export {
  SegmentSurfaceProvider,
  useSegmentSurface,
} from './SegmentSurfaceContext';
export {
  AnalyticsAutocapture,
  type CaptureScope,
} from './autocapture/AnalyticsAutocapture';
export { logAutocaptureError } from './autocapture/errors';
export {
  trackableProps,
  analyticsLocationProps,
  ANALYTICS_ATTRS,
  type TrackableParams,
  type AnalyticsDataAttributes,
} from './autocapture/trackableProps';
export {
  analyticsSurface,
  analyticsManualProps,
  analyticsExcludeProps,
  type AnalyticsSurfaceParams,
} from './autocapture/analyticsSurface';
export { useAnalyticsSurfaceView } from './autocapture/useAnalyticsSurfaceView';
export {
  componentInteractionAuto,
  type AutoItem,
} from './componentInteractionAuto';
export { type ComponentType } from './types/ComponentType';
export { useEventBatch } from './hooks/useEventBatch';
export type {
  UseEventBatchProps,
  UseEventBatchResult,
} from './hooks/useEventBatch';
export { useDwellObserver } from './hooks/useDwellObserver';
export { useTrackingReady } from './hooks/useTrackingReady';
export type {
  UseDwellObserverProps,
  UseDwellObserverResult,
} from './hooks/useDwellObserver';

function getOrigin() {
  return window.location.origin;
}

export type OrderPagePositionType = {
  order_id: number | null;
  button_name: string;
  page_position: string;
  item_type?: 'pairing' | 'product';
  pairing_id?: number;
  pairing_name?: string;
  product_id?: number;
  product_name?: string;
  object_index?: number;
  object_total?: number;
  badge_shown?: boolean;
  personalized_badges?: string[];
  out_of_stock?: boolean;
  coming_soon?: boolean;
  // ISO `YYYY-MM-DD`. Set by first-order checkout, where the delivery date the
  // visitor picked is part of what the click means.
  first_delivery_date?: string;
  // Exp 220 plan editor "i" buttons: which occasion's info was opened.
  occasion?: string;
};

export type ButtonClickedParams = {
  button_type?: string;
  target_url?: string;
  target_url_path?: string;
  conversation_id?: string;
  full_story_link?: string;
  /**
   * Overrides the `page_name` derived from `getPathPageName()`.
   *
   * Needed where one route serves two audiences that Data Analytics reports
   * separately — `/discover/feed/` is `discover_feed_unpersonalized` for a
   * prospect and `home_feed` for a guest — which a path-keyed lookup cannot
   * express. Omit it everywhere else so the route mapping stays the single
   * source of truth.
   */
  page_name?: string;
} & (
  | OrderPagePositionType
  | {
      quantity_type: string;
      container_name: string;
      container_id: number;
      event_name: string;
    }
);

export async function getAnonymousId() {
  const user = await analytics.user();
  return user.anonymousId();
}

export function buttonClickedEvent(params: ButtonClickedParams) {
  const defaultValue = {
    client: 'Web',
    event_name: 'Button Clicked',
    referrer_url: window.location.href,
    page_name: getPathPageName(),
  };

  const event = { ...defaultValue, ...params };
  if (event.target_url_path && !event.target_url) {
    event.target_url = getOrigin() + params.target_url_path;
  }

  if ('button_name' in event && typeof event.button_name === 'string') {
    event.button_name = snakeCase(event.button_name);
  }

  analytics.track('Button Clicked', event);
}

interface UserSearchedParams {
  /** The customer's next order. Absent for a pre-checkout prospect or guest. */
  order_id?: number;
}

export function userSearchedEvent(params: UserSearchedParams = {}) {
  const defaultValue = {
    event_name: 'Has Used Search',
    context_app_name: 'Hungryroot Web',
    referrer_url: window.location.href,
  };

  const event = { ...defaultValue, ...params };
  analytics.track('Has Used Search', event);
}
